import "core-js/modules/es.array.push.js";
import Utils from '@/utils/utils';

// 文档：https://github.com/marcuswestin/WebViewJavascriptBridge#usage
function setupWebViewJavascriptBridge(callback) {
  // Android使用
  if (Utils.isAndroid) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        callback(window.WebViewJavascriptBridge);
      }, false);
    }
  }

  // iOS使用
  if (Utils.isiOS) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

// 注册回调函数，第一次连接时调用 初始化函数(android需要初始化,ios不用)
setupWebViewJavascriptBridge(function (bridge) {
  if (Utils.isAndroid) {
    // 初始化
    bridge.init(function (message, responseCallback) {
      var data = {
        'Javascript Responds': 'Wee!'
      };
      responseCallback(data);
    });
  }
});
export default {
  // js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
  callHandler: function callHandler(name, data, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      console.log(bridge, 'bridge');
      bridge.callHandler(name, data, function responseCallback(responseData) {
        console.log('JS received response:', responseData);
        callback && callback(responseData);
      });
    });
  },
  // APP调js方法 （参数分别为:js提供的方法名  回调）
  registerHandler: function registerHandler(name, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler(name, function (data, responseCallback) {
        console.log('JS Echo called with:', data);
        callback && callback(data, responseCallback);
      });
    });
  }
};